/* <variant-visibility> — shows or hides a whole section depending on the
   option value of the variant selected in Main Product v4.

   Rendered by snippets/variant-visibility.liquid, which also paints the
   server-side initial state so the page never flashes the wrong section.
   The element listens to the `mp4:variant-change` event (which carries the
   selected variant's option values) and, on connect, reads the product
   element's current selection in case that event fired before this script
   registered. */
if (!customElements.get('variant-visibility')) {
  customElements.define(
    'variant-visibility',
    class VariantVisibility extends HTMLElement {
      connectedCallback() {
        this._onVariantChange = this._onVariantChange.bind(this);
        this.target = this.dataset.target ? document.querySelector(this.dataset.target) : null;
        if (!this.target) return;

        document.addEventListener('mp4:variant-change', this._onVariantChange);
        requestAnimationFrame(() => this._syncInitialVariant());
      }

      disconnectedCallback() {
        document.removeEventListener('mp4:variant-change', this._onVariantChange);
      }

      _onVariantChange(event) {
        const detail = event.detail || {};
        if (String(detail.productId) !== String(this.dataset.productId)) return;
        if (Array.isArray(detail.options)) this._apply(detail.options);
      }

      /* Main Product v4 resolves its initial variant on connect, which can
         happen before this element is defined — read its state directly. */
      _syncInitialVariant() {
        const mainProduct = Array.from(document.querySelectorAll('main-product-v4')).find(
          (element) => String(element.dataset.productId) === String(this.dataset.productId)
        );
        const variant = mainProduct && mainProduct.selectedVariant;
        if (variant && Array.isArray(variant.options)) this._apply(variant.options);
      }

      _apply(options) {
        const wanted = (this.dataset.optionValue || '').trim().toLowerCase();
        if (!wanted) return;
        const matches = options.some((value) => String(value).trim().toLowerCase() === wanted);
        // `is-variant-shown` releases the server-side "hidden until decided"
        // rule; `is-variant-hidden` is the live state from then on.
        this.target.classList.add('is-variant-shown');
        this.target.classList.toggle('is-variant-hidden', !matches);
      }
    }
  );
}
